<script setup lang="ts">
import { eventBus } from "#bb/lib/eventBus";
import { useTemplating, buildTemplateContext } from "#bb/composables/useTemplating";
import { resolveResourcePath, toFileApiPath } from "#bb/lib/pathContract";

const logger = useLogger("ResourceInclude");

/** Expect 'id' from parent (same as other blocks) */
const props = defineProps<{ id: string }>();

/** Access the store’s read method only */
const { getContentById } = useContentManager();

/** Read only computed property wrapping the block definition. */
const definitionData = computed(() => getContentById(props.id));

// Inject optional report for templating of path
const report = inject<any | null>("report", null);
const templateContext = computed(() => buildTemplateContext(report));
const { applyTemplate } = useTemplating(templateContext, { logger });
const templatedPath = computed(() => applyTemplate(definitionData.value?.definitionPath || ""));
const features = inject<{
  resourceDefinitionPath?: string | null;
}>("render-features", {});
const resourcePath = computed(() => toFileApiPath(resolveResourcePath(
  templatedPath.value,
  features.resourceDefinitionPath,
)));

// 4. Define a context menu "Edit" command.
const commands = [
  {
    id: "editors-group",
    type: "group",
    name: "Editors",
    description: "Resource editors",
    commands: [
      {
        id: "edit",
        name: "Edit",
        description: "Edit this resource block",
        action: async () => {
          eventBus.emit(`component:onEdit:${props.id}`, {
            data: definitionData.value,
          });
        },
        icon: "lucide:edit",
      },
    ],
  },
];

defineExpose({
  commands,
  properties: {
    id: props.id,
    name: "Resource Include",
    icon: "lucide:link-2",
  },
});
</script>

<template>
  <resource-renderer :resource-path="resourcePath" mode="viewer" />

</template>

<script lang="ts">
import { ComponentDefinitionIds } from "#bb/lib/componentDefinitionIds";
export default {
  componentId: ComponentDefinitionIds.RESOURCE_INCLUDE,
  id: "resource-include",
  icon: "lucide:link-2",
  editor: () => import("#bb/components/editor/content/resource-include.vue"),
  type: "Resource Include",
  description:
    "Includes another resource definition by relative path and renders its content.",
  default: {
    definitionPath: "",
  },
  categories: ["Containers"],
  order: 12010,
};
</script>
